import React,{useEffect, useState} from "react";
import Select from "react-select";
import styles from "./ManageCopyTableHead.module.css";
import { SelectStyle } from "../../../General/Selector/Selector";
import ManageCopyTableFilters from "./ManageCopyTableFilters/ManageCopyTableFilters";
//import { ReactComponent as Menu } from "../../../../assets/icons/Menu.svg";
//import { ReactComponent as Calendar } from "../../../../assets/icons/Calendar.svg";

const options = [
    { label: "Latest Created", value: "latestCreated" },
    { label: "Oldest Created", value: "oldestCreated" },
    { label: "Latest Published", value: "latestPublished" },
    { label: "Oldest Published", value: "oldestPublished" }
];

const ManageCopyTableHead = ({ onSortChange, onFiltersChange, filters }) => {
    const [defaultValueSort,setDefaultValueSort] = useState();

    useEffect(()=>{
     if(Object.keys(filters).length > 0){
        setDefaultValueSort(null)
     }
    },[filters])

    const selectStylesApiObject = React.useMemo(() => {
        return {
            ...SelectStyle,
            control: provided => ({
                ...provided,
                border: ".1rem solid #CECFD0"
            })
        };
    }, []);

    return <div className={styles.TableHead}>
        <div className={styles.TableHeadLeft}>
            <div className={styles.SortByContainer}>
                <label className={styles.SortBy}>Sort By</label>
                <Select className={styles.SortBySelect}
                    styles={selectStylesApiObject}
                    value={defaultValueSort}
                    isClearable
                    options={options}
                    onChange={(sortByOption) => {
                        setDefaultValueSort(sortByOption);
                        onSortChange(
                            sortByOption ? sortByOption.value : undefined);
                    }}
                />
            </div>
            <ManageCopyTableFilters onFiltersChange={onFiltersChange} filters={filters} />
            {/* <div style={{ marginLeft: "90rem", display: "flex" }}>
                <Menu className={styles.Menu} />
                <Calendar className={styles.Calendar1} />
                </div> */}
        </div>
    </div>;
};

export default ManageCopyTableHead;